var EmailFormOptimizedContactChannelView, SharedFooterUSPhoneNumberView, SupportEmailFormUSMainView, SupportEmailFormUSV2FlexibleContactChannelsView, SupportPhoneNumberCallBackView, SupportV1StepThreeBaseView, SupportV1USStepThreeView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportEmailFormUSMainView = require('../../email_form/US/main_view');

EmailFormOptimizedContactChannelView = require('../../email_form/common/optimized_contact_channel_view');

SharedFooterUSPhoneNumberView = require('../../../../../shared/frontend/views/footer/US/phone_number_view');

SupportPhoneNumberCallBackView = require('../../email_form/US/phone_number_call_back_view');

SupportV1StepThreeBaseView = require('../v1_base_view');

SupportEmailFormUSV2FlexibleContactChannelsView = require('../../email_form/US/v2_flexible_contact_channels');

SupportV1USStepThreeView = (function(superClass) {
  extend(SupportV1USStepThreeView, superClass);

  function SupportV1USStepThreeView() {
    return SupportV1USStepThreeView.__super__.constructor.apply(this, arguments);
  }

  SupportV1USStepThreeView.prototype.getEmailFormView = function(options) {
    return new SupportEmailFormUSMainView(options);
  };

  SupportV1USStepThreeView.prototype.renderPhoneNumberView = function() {
    if (window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.shouldDisplayCallBackOption : void 0)) {
      return this.renderPhoneNumberCallBackView();
    } else {
      return this.renderNormalPhoneNumberView();
    }
  };

  SupportV1USStepThreeView.prototype.renderNormalPhoneNumberView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        var phoneNumberView;
        phoneNumberView = new SharedFooterUSPhoneNumberView();
        return phoneNumberView.render();
      };
    })(this));
  };

  SupportV1USStepThreeView.prototype.renderPhoneNumberCallBackView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        _this.phoneNumberCallBackView = new SupportPhoneNumberCallBackView({
          mainView: _this
        });
        return _this.phoneNumberCallBackView.render();
      };
    })(this));
  };

  SupportV1USStepThreeView.prototype.shouldShowContactChannelView = function() {
    return false;
  };

  SupportV1USStepThreeView.prototype.configureContactChannelView = function(options) {
    return null;
  };

  SupportV1USStepThreeView.prototype.renderContactChannelView = function() {};

  SupportV1USStepThreeView.prototype.handleDisplayOfContactChannels = function() {};

  SupportV1USStepThreeView.prototype.renderContactChannelView = function() {
    var hideInbentaResults;
    SupportV1StepThreeBaseView.prototype.renderContactChannelView.apply(this, arguments);
    hideInbentaResults = (function(_this) {
      return function() {
        var inbentaResults;
        inbentaResults = $("#results:visible");
        if (inbentaResults.length > 0) {
          inbentaResults.hide();
          return clearInterval(_this.hideInbentaResultsInterval);
        }
      };
    })(this);
    return this.hideInbentaResultsInterval = setInterval(hideInbentaResults, 0);
  };

  SupportV1USStepThreeView.prototype.renderEmailForm = function() {
    if (this.hideInbentaResultsInterval) {
      clearInterval(this.hideInbentaResultsInterval);
    }
    return SupportV1StepThreeBaseView.prototype.renderEmailForm.apply(this, arguments);
  };

  SupportV1USStepThreeView.prototype.postEmailFormRenderCallBack = function() {
    return Groupon.Support.ContentModel.onInitStepThree();
  };

  return SupportV1USStepThreeView;

})(SupportV1StepThreeBaseView);

module.exports = SupportV1USStepThreeView;

//# sourceMappingURL=data:application/json;base64,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
